import { MutationFn, UseQueryFn } from 'shared-ui';

import { Owner } from 'api/owners/owners.types';
import { PaginatedResponse } from 'core/global.types';
import { JobIdResponse } from 'api/jobs/jobs.types';

import {
  AddGroupBody,
  AddMultiPermissionsBody,
  Group,
  UpdateGroupBody,
  UpdateGroupResponse,
  CreateGroupResponse,
  CopyGroupBody,
  GroupHistory,
  GroupPermissionHistory,
  AddMultiOwnersBody,
} from './groups.types';

export const fetchGroupsForSpecificOwner: UseQueryFn<string, PaginatedResponse<Group>> = (id) => {
  return {
    endpoint: `/pkd/${id}/grupa`,
  };
};

export const fetchGroups: UseQueryFn<unknown, PaginatedResponse<Group>> = () => {
  return {
    endpoint: `/grupa`,
  };
};

export const addGroup: MutationFn<{ body: AddGroupBody }, CreateGroupResponse> = ({ body }) => {
  return {
    endpoint: `/grupa`,
    method: 'POST',
    body,
  };
};

export const updateGroup: MutationFn<{ id: string; body: UpdateGroupBody }, UpdateGroupResponse> = ({ id, body }) => {
  return {
    endpoint: `/grupa/${id}`,
    method: 'PUT',
    body,
  };
};

export const deleteGroup: MutationFn<string, null> = (id) => {
  return {
    endpoint: `/grupa/${id}`,
    method: 'DELETE',
  };
};

export const copyGroup: MutationFn<{ body: CopyGroupBody }, CreateGroupResponse> = ({ body }) => {
  return {
    endpoint: `/grupa/kopiuj`,
    method: 'POST',
    body,
  };
};

export const fetchGroupAssignedOwners: UseQueryFn<string, PaginatedResponse<Owner>> = (id) => {
  return {
    endpoint: `/grupa/${id}/pkd`,
  };
};

export const deleteGroupAssignedOwners: MutationFn<{ id: string; body: string[] }, JobIdResponse> = ({ id, body }) => {
  return {
    endpoint: `/batch/grupa/${id}/pkd`,
    method: 'DELETE',
    body,
  };
};
export const addMultiOwners: MutationFn<AddMultiOwnersBody, JobIdResponse> = (body) => {
  return {
    endpoint: `/batch/grupa/pkd`,
    method: 'POST',
    body,
  };
};

export const addMultiPermissions: MutationFn<AddMultiPermissionsBody, JobIdResponse> = (body) => {
  return {
    endpoint: `/batch/grupa/tkd`,
    method: 'POST',
    body,
  };
};

export const fetchGroupDetails: UseQueryFn<string, Group> = (id) => {
  return {
    endpoint: `/grupa/${id}`,
  };
};

export const fetchGroupHistory: UseQueryFn<string, PaginatedResponse<GroupHistory>> = (id) => {
  return {
    endpoint: `/grupa/${id}/historia`,
    method: 'GET',
  };
};

export const fetchGroupPermissionHistory: UseQueryFn<string, PaginatedResponse<GroupPermissionHistory>> = (id) => {
  return {
    endpoint: `/grupa/${id}/historia/uprawnienia`,
    method: 'GET',
  };
};

export const archiveGroup: MutationFn<string, Group> = (id) => {
  return {
    endpoint: `/grupa/${id}/archiwizuj`,
    method: 'POST',
  };
};

export const unarchiveGroup: MutationFn<string, Group> = (id) => {
  return {
    endpoint: `/grupa/${id}/przywroc`,
    method: 'POST',
  };
};

export const archiveMultiGroups: MutationFn<{ body: string[] }, void> = ({ body }) => {
  return {
    endpoint: '/batch/grupa/archiwizuj',
    method: 'POST',
    body,
  };
};

export const unarchiveMultiGroups: MutationFn<{ body: string[] }, void> = ({ body }) => {
  return {
    endpoint: '/batch/grupa/przywroc',
    method: 'POST',
    body,
  };
};
